<!--
 * @Description: 机构详情组件
 * @Author: wanqian
 * @Date: 2022-03-28 16:43:52
-->
<template>
   <div class="body">
    <el-dialog class="dialog-inst" width="1000px" :title="dialogTitle" :visible.sync="visible" 
      :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center>
      <div class="bk-steps">
        <el-steps :active="active" finish-status="success" align-center style="width: 660px;">
          <el-step title="基本信息" :status="stepStatus(0)"></el-step>
          <el-step title="服务开通" :status="stepStatus(1)"></el-step>
        </el-steps>
      </div>
      <div class="dialog-body">
        <baseinfo-panel v-if="active == 0" @panel-operate="handlePanelOperate"/>
        <openhservice-panel v-if="active == 1" @panel-operate="handlePanelOperate"/>
      </div>
    </el-dialog>
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import instStore from './institutiondetails/InstStore.js'
import BaseInfoPanel from "./institutiondetails/InstBaseInfoPanel.vue";
import OpenHservicePanel from "./institutiondetails/InstOpenHservicePanel.vue";

export default {
  name: 'InstitutionDetails',
  
  props: ["visible", "mode", "instid",],
  instStore,

  components: {
    'baseinfo-panel'    : BaseInfoPanel,
    'openhservice-panel': OpenHservicePanel,
  },

  data() {
    return {
      active: 0,
    }
  },

  computed: {
    dialogTitle() {
      switch (this.mode) {
        case 'add'    : return "新增机构";
        case 'edit'   : return "编辑机构";
        case 'details': return "机构详情";
        default       : return "----";
      } 
    },
    
    stepStatus() {
      return function(curActive) {
        return (curActive <= this.active) ? 'finish' : 'wait';
      }
    },
  },
  
  methods:{
    async initData() {
      this.clearData();
      instStore.commit("changeMode", this.mode);
      this.active = 0;
      let instDO = await this.queryData();
      instStore.commit('changeBaseInfoDO', instDO.baseInfoDO);
      instStore.commit('changeOpeningHsvcList', instDO.openingHsvcList);
      instStore.commit('changeBrandingFiles', instDO.baseInfoDO.institution.aboutUsPathLists);
      instStore.commit('changeSrcProvinceList', instDO.baseInfoDO.provinceList);
      if (this.mode == 'edit') {
        let cityList = await this.requsetCityList(instDO.baseInfoDO.institution.provinceId);
        let countyList = await this.requsetCountyList(instDO.baseInfoDO.institution.cityId);
        instStore.commit('changeSrcCityList', cityList);
        instStore.commit('changeSrcCountyList', countyList);
      }
    },

    queryData() {
			return new Promise((resolve) => {
        let url = '';
				switch (this.mode) {
					case 'add': 
						url = Constant.URL_GET_INSTITUTIONDO_4_ADD
						break;
					case 'edit': 
						url = Constant.URL_GET_INSTITUTIONDO_4_UPDATE;
						break;
					case 'details': 
						url = Constant.URL_GET_INSTITUTION;
						break;
				}
        let params = this.mode == 'add' ? {} : {id: this.instid};
			  let header = this.encryptionUtil.signatureParams(params,
			  	Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET', 
          url: url,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED
        };
				this.vueRequest(requestData).then(result => {
					if (result != null) {
						resolve(result.data);
					}
				})
			})
    },

		requsetCityList(id) {
      return new Promise((resolve) => {
        let urlListCity = this.commonUtil.fillUrlArgments(this.commonUrl.URL_LIST_COMMON_CITY, id);
				this.appAxios("GET", urlListCity).then(resultCity => {
					if (resultCity != null) {
						resolve(resultCity.data);
					}
				})
      })
    },

		requsetCountyList(id) {
      return new Promise((resolve) => {
        let urlListCountry = this.commonUtil.fillUrlArgments(this.commonUrl.URL_LIST_COMMON_COUNTY, id);
				this.appAxios("GET", urlListCountry).then(resultCountry => {
					if (resultCountry != null) {
						resolve(resultCountry.data);
					}
				})
      })
    },

    clearData() {
      this.active = 0;
      instStore.commit('changeBaseInfoDO', {institution: {},});
      instStore.commit('changeLogoFile', null);
      instStore.commit('changePicFile', null);
      instStore.commit('changeBrandingFiles', null);
			instStore.commit('changeSrcProvinceList', []);
			instStore.commit('changeSrcCityList', []);
			instStore.commit('changeSrcCountyList', []);
    },

    handlePanelOperate(opr) {
      switch(opr) {
        case 'prev': 
          this.handlePrev();
          break;
        case 'next':
          this.handleNext();
          break;
        case 'ok':
          this.handleCancel();
          break;
        case 'add':
        case 'edit':
          this.handleSubmit(opr);
          break;
        case 'cancel':
          this.handleCancel();
          break;
      }
    },

    handlePrev() {
      if (this.active > 0) this.active--;
    },

    handleNext() {
      if (this.active < 2) this.active++;
    },

    handleSubmit(_opr) {
      if (!this.vaildHsvcTimeRange(instStore.state.openingHsvcList)) {
        this.$message.error('开始时间和结束时间不能相同');
        return;
      }
      let url = (this.mode == 'add') ? Constant.URL_SAVE_INSTITUTION : Constant.URL_UPDATE_INSTITUTION;
      let method = (this.mode == 'add') ? 'POST' : 'PUT';
      let fileMap = this.getFileMap();
      let param = this.rebuildParam();
      let header = this.encryptionUtil.signatureObjectParam(
        param, Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        url: url,
        method: method,
        param: param,
        header: header,
        files: fileMap,
        contentType: this.commonConst.CNTYPE_JSON,
      };

      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.clearData();
          if (this.mode == 'add') {
            this.$emit("close-dialog", true, result.data.id);
          } else {
            this.$emit("close-dialog", true);
          }
        }
      })    
    },

    getFileMap() {
      let fileMap = new Map();
      if (instStore.state.logoFile && instStore.state.logoFile.raw) {
        fileMap.set('logoFile', instStore.state.logoFile.raw);
      }
      if (instStore.state.picFile && instStore.state.picFile.raw) {
        fileMap.set('licenseFile', instStore.state.picFile.raw);
      }
      if (instStore.state.brandingFiles && instStore.state.brandingFiles.length) {
        let imgsList = [];
        /* 新增的本地file需要循环拼接到aboutUsFileLists，不能直接拼接图片对象数组，编辑的图片需要携带aboutUsPathLists，
        包括之前的图片url以及更换的file的名字 */
        instStore.state.brandingFiles.forEach((item, _index) => {
          if (typeof item == 'object' && item.file && item.file.raw) {
            imgsList.push(item.file.raw)
          }
        });
        if (imgsList.length) fileMap.set('aboutUsFileLists', imgsList);
      }
      return fileMap;
    },

    rebuildParam() {
      let obj = {"institution": instStore.state.baseInfoDO.institution,
                  "openingHsvcList": this.filterOpeningHsvcList(instStore.state.openingHsvcList)};
      if (instStore.state.brandingFiles && instStore.state.brandingFiles.length) {
        let aboutUsPathLists = [];
        instStore.state.brandingFiles.forEach((item, _index) => {
          if (typeof item == 'object' && item.file && item.file.raw) {
            aboutUsPathLists.push(item.file.name);
          } else if (typeof item == 'string') {
            aboutUsPathLists.push(item);
          }
        });
        if (this.mode == 'edit') {
          obj.institution.aboutUsPathLists = aboutUsPathLists;
        }
      }
      return {'name': 'instVO', 'value': {...obj}};
    },

    vaildHsvcTimeRange(list) {
      let result = true;
      list.forEach((item) => {
        if (item.timeRange[0] == item.timeRange[1]) {
          result = false;
        }
      })
      return result;
    },

    //过滤开通服务列表去掉逻辑显示用的timeRange字段
    filterOpeningHsvcList(list) {
      let opendList = [];
      list.forEach((item) => {
        let obj = JSON.parse(JSON.stringify(item));
        obj.startTime = obj.timeRange[0].indexOf('2016-09-10 ') == -1 ? obj.timeRange[0] 
          : obj.timeRange[0].substr(11);
        obj.endTime = obj.timeRange[1].indexOf('2016-09-10 ') == -1 ? obj.timeRange[1] 
          : obj.timeRange[1].substr(11);
        this.$delete(obj,'timeRange');
        opendList.push(obj)
      })
      return opendList;
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },
  },
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.bk-steps {
  display: flex;
  justify-content: center;
}
.dialog-inst /deep/ .el-dialog--center .el-dialog__body {
  padding: 25px 0 0;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/InstitutionDetails.vue